export default __webpack_public_path__ + "static/media/requisition-icon.2a4a6e0e.svg";